<div class="brands-list box-container" [class.brands-list--full]="brands()?.length" #container>
    @if (brands()?.length) {
        @for (brand of brands(); track brand.id) {
            <lib-brand
                class="brands-list__item"
                #brandItem
                role="button"
                [ariaLabel]="brand.name"
                [brandName]="brand.name"
                [maxWidth]="80"
                [url]="themeService.isDark() ? brand?.logoByType?.White?.url : brand?.logoByType?.Color?.url"
                (libAccessibleClick)="clickBrand(brand)"
            />
        }
    } @else {
        <ngx-skeleton-loader animation="progress-dark" [count]="4" [theme]="skeletonConfig" />
    }
</div>
